import { render, staticRenderFns } from "./JiZhiBiView.vue?vue&type=template&id=408c7ae2&scoped=true"
import script from "./JiZhiBiView.vue?vue&type=script&lang=js"
export * from "./JiZhiBiView.vue?vue&type=script&lang=js"
import style0 from "./JiZhiBiView.vue?vue&type=style&index=0&id=408c7ae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c7ae2",
  null
  
)

export default component.exports